module.exports = "https://cdn.hellotech.com/client-assets/light-blue-blob_c18ba7d160656907f0fc222748f4480c.svg";